module.exports = __webpack_public_path__ + "static/media/broadwayDrink.dba1adc1.pdf";